import styled from "styled-components";
import { Link } from "react-router-dom";
import { StaggerReveal, MotionItem } from "../../ui/Motion";

export const Header = styled(StaggerReveal)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing["3xl"]};
`;

export const Grid = styled(StaggerReveal)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spacing.xl};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.lg};
  }
`;

export const PillarCard = styled(MotionItem)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => theme.spacing["2xl"]};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  transition: all ${({ theme }) => theme.transitions.normal};
  text-decoration: none;
  color: inherit;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;

  /* Hover only on devices that actually hover (mouse/trackpad) — on touch
     devices tapping a card must not leave it stuck in a hover/focus state. */
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow:
        0 16px 40px rgba(59, 84, 109, 0.16),
        0 4px 12px rgba(112, 141, 171, 0.1);
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const IconWrap = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ theme }) => theme.colors.pearl};
  color: ${({ $accent, theme }) =>
    $accent === "gold" ? theme.colors.gold : theme.colors.primary};
  border: 1px solid
    ${({ $accent }) =>
      $accent === "gold"
        ? "rgba(201, 169, 110, 0.35)"
        : "rgba(112, 141, 171, 0.28)"};
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);

  svg {
    width: 28px;
    height: 28px;
  }
`;

export const PillarTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const PillarDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  color: ${({ theme }) => theme.colors.textSecondary};
  flex: 1;
`;

export const PillarLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  margin-top: auto;
  transition: color ${({ theme }) => theme.transitions.fast};

  &::after {
    content: "→";
    transition: transform ${({ theme }) => theme.transitions.normal};
  }

  @media (hover: hover) and (pointer: fine) {
    ${PillarCard}:hover & {
      color: ${({ theme }) => theme.colors.primaryDark};
    }

    ${PillarCard}:hover &::after {
      transform: translateX(4px);
    }
  }
`;
